import React, { useCallback, useEffect, useState } from 'react';
import { getLoginHistory } from './myPageApi';

const methodLabels = { email: '이메일', naver: '네이버' };

// User-Agent에서 브라우저와 운영체제 이름만 간단히 뽑아 '브라우저 · OS' 형태로 만든다.
function summarizeUserAgent(userAgent = '') {
    const browser = [[/Edg\//, 'Edge'], [/Whale\//, '웨일'], [/SamsungBrowser\//, '삼성 인터넷'], [/Chrome\//, 'Chrome'], [/Firefox\//, 'Firefox'], [/Safari\//, 'Safari']]
        .find(([pattern]) => pattern.test(userAgent))?.[1];
    const os = [[/Windows/, 'Windows'], [/Android/, 'Android'], [/iPhone|iPad/, 'iOS'], [/Mac OS X/, 'macOS'], [/Linux/, 'Linux']]
        .find(([pattern]) => pattern.test(userAgent))?.[1];
    return [browser, os].filter(Boolean).join(' · ') || '알 수 없는 기기';
}

// 로그인 일시를 한국 시간 표기(YYYY. MM. DD. HH:mm)로 바꾼다.
function formatDateTime(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
}

// 최근 로그인 기록 목록. 펼칠 때 GET /api/mypage/login-history를 호출한다.
export default function LoginHistory() {
    const [items, setItems] = useState(null);
    const [error, setError] = useState('');

    // 로그인 기록을 불러와 상태에 넣는다.
    const load = useCallback(async () => {
        setError('');
        setItems(null);
        try {
            setItems(await getLoginHistory());
        } catch (loadError) {
            setError(loadError.message);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    if (error) return <div className="my-page-history" role="alert"><p className="my-page-field-error">{error}</p><button type="button" className="my-page-button my-page-retry" onClick={load}>다시 시도</button></div>;
    if (!items) return <p className="my-page-notice" role="status">로그인 기록을 불러오고 있습니다.</p>;
    if (items.length === 0) return <p className="my-page-notice">로그인 기록이 없습니다.</p>;

    return <ol className="my-page-history">
        {items.map(item => <li key={item.id}>
            <strong>{formatDateTime(item.loggedInAt)}</strong>
            <span>{methodLabels[item.method] || item.method || '-'}</span>
            <span title={item.userAgent}>{summarizeUserAgent(item.userAgent)}</span>
            <span className="my-page-meta">{item.ip || '-'}</span>
        </li>)}
    </ol>;
}
